import React, { Component } from "react";
import App from "./App";
import db from "./pages";
import { getCookie, checkIfFastpathAllowed, reverseHash, setCookie } from "./components/oro-module/commonFunctions";

window.onbeforeunload = function () {
  window.location = "/";
}


class AppWrapper extends Component {
  constructor(props) {
    super(props);
    let encpath = window.location.pathname;
    if (encpath.indexOf('/enc-') != -1) {
      encpath = reverseHash(decodeURIComponent(encpath.replace("/enc-", "")));
    }
    setCookie("requiredFields", JSON.stringify({}));

    let ws = encpath.split('/');
    // Decrypt ws to get, fastpath, identi, var3

    let curpath = ws[1];

    if (!curpath || curpath == 'home') {
      curpath = "dashboard1";
    }

    if (curpath == 'calamity_fund_uploads' && ws.length == 2) {
      window.location = '/dashboard1';
    }


    let identi;
    let val3;
    let val4;
    if (ws.length > 2) {
      let sp = encpath.split('/');
      identi = sp[2];
      val3 = sp[3];
      val4 = sp[4];
      // dataType="edit",
      // fileFolder.isOpen =true
    }
    let mycookie = getCookie("orosession");
    let mypagcolor = getCookie("themecolor");

    let profilecookie = getCookie("profile");
    let orosession; let profile;
    if (profilecookie) {
      profile = JSON.parse(profilecookie);
    }

    if (mycookie && mycookie != '[]') {
      orosession = JSON.parse(mycookie);
      if (curpath == 'login') {
        window.location = '/';
      }
    } else {
      if (curpath != 'login' && curpath != 'websearch') {
        window.location = '/login';
      }
      orosession = { authenticated: false, token: "", session_date: "", user_code: "", user_description: "", assigned_roles: "", assigned_branch: "" };
    }

    if (!db[curpath] && ["login", "websearch"].indexOf(curpath) == -1) {
      alert("Invalid option");
      window.location = "/";
    }

    let { token, session_date, authenticated, user_code, user_description, assigned_roles, assigned_branch } = orosession;
    this.state = { errorMessages: {}, identi, val3, val4, currentPage: curpath, dataPages: db, authenticated: (authenticated == false || authenticated == 'false') ? false : true, token, session_date, user_code, user_description, assigned_roles, assigned_branch, errorMessages: {}, themecolor: mypagcolor, profile };
  }

  liftGlobalState = (componentInfo, stateValue) => {
    this.setState({ [componentInfo.name]: stateValue });
    this.setState({ dataPages: db });
  }

  render() {

    // console.log({ CP: this.state });
    // debugger;

    return <App parentState={this.state} liftGlobalState={this.liftGlobalState} />

  }
}

export default AppWrapper;
